import { useLocalStorage } from "react-migration/lib/persistence/state/useLocalStorage";
import hasBetaFeature from "./hasBetaFeature";
import Feature from "../Feature";

export const getNewExperienceLocalStorageKey = () => {
  const defaultToNewExploreExperience = hasBetaFeature(Feature.newExploreExperienceDefault);

  const exploreExperienceLocalStorageKey = defaultToNewExploreExperience
    ? "explore-default-new-experience"
    : "explore-new-experience";

  return exploreExperienceLocalStorageKey;
};

export const useShowNewExperience = () => {
  const exploreExperienceLocalStorageKey = getNewExperienceLocalStorageKey();
  const defaultToNewExploreExperience = hasBetaFeature(Feature.newExploreExperienceDefault);

  const [showNewExperience, setShowNewExperience] = useLocalStorage<boolean>(
    exploreExperienceLocalStorageKey,
    defaultToNewExploreExperience
  );

  return [showNewExperience, setShowNewExperience] as const;
};
